import { useState } from "react";

import CompareArrowsRoundedIcon from "@mui/icons-material/CompareArrowsRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import History from "./History/History";
import QueryRunnner from "./QueryRunnner/QueryRunnner";

function a11yProps(index) {
	return {
		id: `uc-ginesys-tab-${index}`,
		"aria-controls": `uc-ginesys-tabpanel-${index}`,
	};
}

const UcVsGynesis = () => {
	const [tab, setTab] = useState(0);
	const [history, setHistory] = useState();

	return (
		<Box
			sx={{
				width: "100%",
				minHeight: "calc(100vh - 60px)",
				boxSizing: "border-box",
				bgcolor: "#f7f8fa",
				px: { xs: 2, sm: 2.5, md: 3 },
				py: { xs: 2, md: 2.5 },
			}}>
			<Stack direction="row" spacing={1.5} alignItems="center" mb={2.5}>
				<Box
					sx={{
						width: 40,
						height: 40,
						borderRadius: 1.5,
						display: "grid",
						placeItems: "center",
						bgcolor: "#fff",
						border: "1px solid #e6e8ec",
						color: "#111827",
						flexShrink: 0,
					}}>
					<CompareArrowsRoundedIcon sx={{ fontSize: 22 }} />
				</Box>
				<Box minWidth={0}>
					<Typography
						component="h1"
						sx={{ fontSize: { xs: "1.25rem", sm: "1.4rem" }, fontWeight: 700, color: "#111827", lineHeight: 1.2 }}>
						UC vs Ginesys
					</Typography>
					<Typography variant="body2" color="text.secondary" sx={{ mt: 0.35 }}>
						Compare Unicommerce and Ginesys across sales, returns, ledger, payments, GRN, stock, TIR, and TOR.
					</Typography>
				</Box>
			</Stack>

			<Box
				sx={{
					bgcolor: "#fff",
					border: "1px solid #e6e8ec",
					borderRadius: 2,
					overflow: "hidden",
				}}>
				<Tabs
					value={tab}
					onChange={(_, value) => setTab(value)}
					sx={{
						px: 1,
						minHeight: 48,
						borderBottom: "1px solid #eef0f3",
						"& .MuiTab-root": {
							textTransform: "none",
							fontWeight: 600,
							fontSize: "0.9rem",
							minHeight: 48,
							color: "#6b7280",
							"&.Mui-selected": { color: "#111827" },
						},
						"& .MuiTabs-indicator": { bgcolor: "#111827", height: 2 },
					}}>
					<Tab icon={<PlayArrowRoundedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Run Query" {...a11yProps(0)} />
					<Tab icon={<HistoryRoundedIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="History" {...a11yProps(1)} />
				</Tabs>

				<Box
					role="tabpanel"
					id="uc-ginesys-tabpanel-0"
					aria-labelledby="uc-ginesys-tab-0"
					sx={{ display: tab === 0 ? "block" : "none" }}>
					<QueryRunnner history={history} setHistory={setHistory} />
				</Box>
				<Box
					role="tabpanel"
					id="uc-ginesys-tabpanel-1"
					aria-labelledby="uc-ginesys-tab-1"
					sx={{ display: tab === 1 ? "block" : "none" }}>
					<History />
				</Box>
			</Box>
		</Box>
	);
};

export default UcVsGynesis;
